import { STATUS } from './constants/statuses'
import { LEVEL, REQUIREMENT, CURRICULUM_VERSION } from './constants/levels'
import {
  mapBackgroundCheckStatus,
  mapPATStatus,
  mapApplicationStatus,
  aggregateStatuses,
} from './statusMappers'
import { hasAdvancedToLevel } from './progressUtils'

export const shouldExcludeRequirement = (reqKey, curriculumVersion) => {
  // Course manuals only exist in curriculum 3.1
  if (reqKey === REQUIREMENT.COURSE_MANUALS && curriculumVersion !== CURRICULUM_VERSION.V3_1) {
    return true
  }

  return false
}

export const resolveRequirementStatus = ({
  levelKey,
  reqKey,
  levelCode,
  data,
}) => {
  const {
    programRequirements,
    prospect,
    associateApplication,
    affiliateApplication,
    memberApplication,
    finalExamStatus,
  } = data

  if (levelKey === LEVEL.QUALIFYING) {
    switch (reqKey) {
      case REQUIREMENT.BACKGROUND_CHECK:
        return mapBackgroundCheckStatus(prospect?.backgroundCheck?.status)

      case REQUIREMENT.PLAYING_ABILITY_TEST:
        return mapPATStatus(
          prospect?.playingAbilityTest,
          prospect?.playingAbilityTestStatus,
        )

      case REQUIREMENT.APPLICATION: {
        const qualifyingApplication =
          associateApplication || affiliateApplication
        return mapApplicationStatus(qualifyingApplication)
      }

      case REQUIREMENT.COURSE_MANUALS: {
        const courseReqs = programRequirements.filter(
          (req) =>
            req.levelCode === levelCode &&
            req.requirementTypeKey === REQUIREMENT.COURSE_MANUALS,
        )
        return aggregateStatuses(courseReqs.map((r) => r.status))
      }

      default:
        return STATUS.READY
    }
  }

  if (levelKey === LEVEL.LEVEL_3) {
    if (reqKey === REQUIREMENT.FINAL_EXAM) {
      return finalExamStatus || STATUS.READY
    }

    if (reqKey === REQUIREMENT.ENROLLMENT) {
      return mapApplicationStatus(memberApplication)
    }
  }

  // Mark Purchase Level requirement complete if the user has already advanced to the next level
  if (reqKey === REQUIREMENT.PURCHASE) {
    const { programHistory, currentLevelCode } = data
    const targetLevelKey = levelKey === LEVEL.LEVEL_1 ? LEVEL.LEVEL_2 : LEVEL.LEVEL_3
    
    if (hasAdvancedToLevel(targetLevelKey, currentLevelCode, programHistory)) {
      return STATUS.COMPLETE
    }
    
    return STATUS.READY
  }

  const matchingReqs = programRequirements.filter(
    (req) => req.levelCode === levelCode && req.requirementTypeKey === reqKey,
  )

  // Aggregate the statuses (if no matching reqs, returns 'ready')
  return aggregateStatuses(matchingReqs.map((r) => r.status))
}
